import { render } from "./MsTrRowSpan.vue?vue&type=template&id=f946be20&scoped=true"
import script from "./MsTrRowSpan.vue?vue&type=script&lang=js"
export * from "./MsTrRowSpan.vue?vue&type=script&lang=js"

import "./MsTrRowSpan.vue?vue&type=style&index=0&id=f946be20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f946be20"]])

export default __exports__